import { useState, useEffect } from "react";

// prevents body from being scrolled unintentionally
export const useDisableBodyScroll = (scrollEl: HTMLElement) => {
  useEffect(() => {
    scrollEl.addEventListener("touchstart", () =>
      document.body.classList.add("no-scroll")
    );
    scrollEl.addEventListener("touchend", () =>
      document.body.classList.remove("no-scroll")
    );
  }, [scrollEl]);
};

export const useNetworkStatus = () => {
  const [isOnline, setIsOnline] = useState(() => {
    // default to online if older browser
    if (typeof navigator.onLine === "undefined") return true;
    return navigator.onLine;
  });

  useEffect(() => {
    const handleOnline = () => setIsOnline(true);
    const handleOffline = () => setIsOnline(false);

    window.addEventListener("offline", handleOffline);
    window.addEventListener("online", handleOnline);

    return () => {
      window.removeEventListener("offline", handleOffline);
      window.removeEventListener("online", handleOnline);
    };
  }, []);

  return isOnline;
};
